var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVkColor = function SvgVkColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.001,
    y: 0.064,
    fill: "#07F",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vk-color_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.43,
    y: 1.492,
    fill: "#07F",
    rx: 2.857
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vk-color_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.573 3.635h13.214v13.214H3.573z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07F",
    d: "m8.208 1.495.52-.002h2.547l.52.002.654.007.309.005.299.008.287.01.278.012.267.015.257.018.246.021.238.024c1.243.14 2.095.44 2.738 1.082s.943 1.495 1.083 2.738l.024.238.02.247.019.257.014.267.018.42.009.293.009.46.006.653.003.7v2.367l-.003.521-.007.653-.005.31-.008.298-.01.288-.011.277-.015.267-.018.257-.021.247-.024.238c-.14 1.242-.44 2.095-1.083 2.737-.643.643-1.494.943-2.738 1.083l-.238.024-.247.021-.257.018-.266.014-.42.018-.293.009-.46.009-.654.006-.7.003H8.73l-.522-.003-.653-.007-.309-.005-.298-.008-.288-.01-.277-.011-.268-.015-.257-.018-.246-.021-.238-.024c-1.243-.14-2.095-.44-2.738-1.083-.643-.642-.943-1.494-1.083-2.737l-.024-.238-.02-.248-.019-.257-.014-.266-.018-.42-.008-.293-.01-.46-.006-.654-.003-.7V8.791l.003-.521.007-.653.005-.31.008-.298.01-.288.011-.277.015-.267.018-.257.022-.247.023-.238c.14-1.243.44-2.095 1.083-2.738s1.494-.942 2.738-1.082l.238-.025.247-.02.257-.018.267-.015.42-.017.292-.009.46-.01zM6.28 6.707H4.323c.093 4.457 2.321 7.135 6.229 7.135h.221v-2.55c1.436.143 2.521 1.193 2.957 2.55h2.029c-.557-2.028-2.022-3.15-2.936-3.578.914-.529 2.2-1.814 2.507-3.557h-1.843c-.4 1.414-1.585 2.7-2.714 2.821V6.707H8.93v4.943c-1.143-.286-2.586-1.672-2.65-4.943"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vk-color_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.43 1.492h17.143v17.143H1.43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vk-color_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.43 1.492h17.143v17.143H1.43z"
  })))));
};
export default SvgVkColor;